export const en = {
    accept: 'Apply',
    cancel: 'Cancel',
    title: 'Enter your username or UID'
};
